import React, { useState } from "react";
import { toast } from "sonner";
import { InstagramLogo, SignOut, Check } from "@phosphor-icons/react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function HandleConfirmGate() {
  const { user, checkAuth, logout } = useAuth();
  const [handle, setHandle] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    const h = handle.trim().replace(/^@+/, "").toLowerCase();
    if (!h) return setError("Informe seu @ do Instagram");
    setSaving(true);
    setError("");
    try {
      const { data } = await api.post("/me/confirm-handle", { handle: h });
      toast.success(data.linked_existing ? `Conta vinculada a ${data.handle}!` : `@ confirmado: ${data.handle}`);
      await checkAuth();
    } catch (err) {
      setError(err?.response?.data?.detail || "Erro ao confirmar o @");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="handle-confirm-gate" className="min-h-screen bg-brand-bg flex items-center justify-center p-4">
      <form onSubmit={submit} className="card-brutal bg-white w-full max-w-md">
        <div className="p-6 bg-brand-pink text-white">
          <p className="text-[11px] font-bold uppercase tracking-widest opacity-90">
            <InstagramLogo weight="bold" size={12} className="inline mr-1" />Primeiro acesso
          </p>
          <h1 className="font-heading text-3xl font-black mt-1">Qual é o seu @ do Instagram?</h1>
          <p className="text-sm mt-2 opacity-90">
            Usamos o seu @ para anotar seus pedidos nas lives. Informe exatamente como aparece no seu perfil.
          </p>
        </div>
        <div className="p-6 space-y-3">
          <label className="label-brutal" htmlFor="confirm-handle-input">Seu @ do Instagram</label>
          <div className="flex items-center gap-2">
            <span className="font-black text-xl">@</span>
            <input
              id="confirm-handle-input"
              data-testid="confirm-handle-input"
              className="input-brutal flex-1"
              value={handle}
              onChange={(e) => setHandle(e.target.value.replace(/\s/g, ""))}
              placeholder="seu.perfil"
              autoFocus
              autoCapitalize="none"
              autoComplete="off"
            />
          </div>
          {error && <p data-testid="confirm-handle-error" className="text-sm font-bold text-red-600">{error}</p>}
          <p className="text-[11px] text-brand-ink2">Conectado como {user?.email}</p>
        </div>
        <div className="p-4 border-t-4 border-brand-ink flex justify-between gap-2 bg-brand-cream">
          <button type="button" data-testid="confirm-handle-logout" onClick={logout} className="btn-white h-[48px]">
            <SignOut weight="bold" size={16} /> Sair
          </button>
          <button type="submit" data-testid="confirm-handle-submit" disabled={saving} className="btn-pink h-[48px] disabled:opacity-60">
            <Check weight="bold" size={16} /> {saving ? "Confirmando…" : "Confirmar"}
          </button>
        </div>
      </form>
    </div>
  );
}
